<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        fluid
        fill-height>
        <v-layout
          align-center
          justify-center>
          <v-flex
            xs12
            md6
            lg6>
            <v-card class="elevation-12">
              <v-toolbar
                dark
                color="primary">
                <v-tooltip bottom>
                  <v-btn
                    slot="activator"
                    icon
                    large
                    href="/">
                    <v-icon large>home</v-icon>
                  </v-btn>
                  <span>{{ $t('home') }}</span>
                </v-tooltip>
                <v-toolbar-title>{{ heading }}</v-toolbar-title>
                <v-spacer/>

                <v-menu left>
                  <v-btn
                    slot="activator"
                    flat
                    icon
                  >
                    {{ this.$i18n.locale }}
                  </v-btn>
                  <v-list>
                    <v-list-tile
                      v-for="language in languagesList"
                      :key="language.id"
                      @click="setI18nLanguage(language.name)"
                    >
                      <v-list-tile-title>{{ languageNames[language.name] }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>

              </v-toolbar>
              <v-card-text>
                <slot/>
              </v-card-text>
              <v-card-actions>
                <slot name="navigation" />
                <v-spacer />
                <slot name="action" />
              </v-card-actions>
            </v-card>
          </v-flex>
          <global-notifications/>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import GlobalNotifications from '@/components/layouts/parts/GlobalNotifications'
import setLayoutClass from '@/utils/setLayoutClass'
import '@/styles/webapp/app.scss'
import { mapGetters } from 'vuex'
import { setI18nLanguage } from '../../locales/i18n-setup'

export default {
  name: 'AuthLayout',
  components: { GlobalNotifications },
  props: ['heading'],
  data () {
    return {
      languageNames: {
        en: 'English',
        ru: 'Русский',
        de: 'Deutsch',
        tr: 'Türkçe'
      }
    }
  },
  computed: {
    ...mapGetters('languages', ['languagesList'])
  },
  methods: {
    setI18nLanguage: setI18nLanguage
  },
  i18n: {
    messages: {
      en: {
        home: 'Homepage',
        errorWhileLoadingTranslations: 'Could not load translations'
      },
      tr: {
        home: 'Ana Sayfa',
        errorWhileLoadingTranslations: 'Çeviriler yüklenemedi'
      },
      de: {
        home: 'Startseite',
        errorWhileLoadingTranslations: 'Konnte Übersetzungen nicht laden'
      },
      ru: {
        home: 'Главная',
        errorWhileLoadingTranslations: 'Не удалось загрузить переводы'
      }
    }
  },
  mounted () {
    setLayoutClass('layout-webapp')
    setI18nLanguage(typeof localStorage.locale === 'undefined' ? 'de' : localStorage.locale)
  }
}
</script>
